import { Transform } from 'class-transformer';
import { IsString, MaxLength } from 'class-validator';
import { sanitizeString } from './utils';

export class DeliveryAddressModel {
  @IsString()
  @MaxLength(20)
  @Transform(({ value }) => sanitizeString(value))
  public zipCode: string;

  @IsString()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public street: string;

  @IsString()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public state: string;

  @IsString()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public name: string;

  @IsString()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public country: string;

  @IsString()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public city: string;
}
